import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

import { ComposableCardConfig } from './card.model';

@Component({
  selector: 'wl-composable-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.ed.scss'],
  standalone: true,
  imports: [NgClass],
})
export class ComposableCardComponent {
  readonly config = input<ComposableCardConfig>();
}
